<script lang="ts" context="module">
  import {writable} from 'svelte/store';
  import {fade, slide} from 'svelte/transition';

  export let eventSourceStore = writable({
    connected: false,
    connecting: false,
    error: false
  });
</script>

{#if $eventSourceStore.error}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    transition:slide={{duration: 150}}
    class="absolute right-0 top-0 z-[2000] w-[500px] p-8"
    on:click|preventDefault={() => {
      console.warn('Actions are not permitted during disconnection.');
    }}
  >
    <div class="alert alert-danger" role="alert">
      <svg class="mr-4 h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
        <path d="M12 8v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <circle cx="12" cy="16" r="1" fill="currentColor" />
      </svg>
      We have identified an issue with your connection. We are trying to reconnect you to the server.
    </div>
  </div>
{/if}

<style lang="postcss">
  .alert {
    @apply pointer-events-none flex h-full w-full items-center justify-center rounded-lg bg-white p-4 font-bold;
    &.alert-warning {
      @apply bg-yellow-400 bg-opacity-55;
    }
    &.alert-danger {
      @apply bg-red-400 bg-opacity-80;
    }
  }
</style>
